/**
 * 전시 GNB 템플릿 매핑 (typeValue=MOBILE)
 *
 * display/gnb-list API 호출을 제거하면서(HSMALL-17123) 해당 응답을 상수화한 것이다.
 * dev/qa/stg/prod 응답이 모두 동일함을 확인했다 (2026-09-02 기준).
 *
 * 전시 어드민에서 GNB 템플릿을 재발번하면 이 표도 함께 갱신해야 한다.
 */
export const GNB_REMODELING_TEMPLATE_NO_BY_MODULE: Record<string, string> = {
  GnbRemodelingSection: '343',
  GnbRemodelingShop: '344',
  GnbRemodelingGoods: '345',
  GnbRemodelingStart: '346',
  GnbRemodelingEvent: '347',
};

export const GNB_MALL_MODULE_BY_TEMPLATE_NO: Record<string, string> = {
  '333': 'home',
  '39': 'deal',
};

/** MALL GNB 하위 SNB (dispTemplateNo → snbCd) */
export const GNB_MALL_SNB_CD_BY_TEMPLATE_NO: Record<string, string> = {
  '334': 'today',
  '336': 'ssem',
  '335': 'oulet',
};

export const GNB_HOMEIDEA_MODULE_BY_TEMPLATE_NO: Record<string, string> = {
  '338': 'recommend',
  '339': 'spaceandphoto',
  '340': 'apartment',
  '341': 'constcase',
  '342': 'magazine',
};

const invert = (source: Record<string, string>) =>
  Object.keys(source).reduce<Record<string, string>>((acc, key) => {
    acc[source[key]] = key;
    return acc;
  }, {});

export const GNB_REMODELING_MODULE_BY_TEMPLATE_NO = invert(
  GNB_REMODELING_TEMPLATE_NO_BY_MODULE,
);

export const GNB_HOMEIDEA_TEMPLATE_NO_BY_MODULE = invert(
  GNB_HOMEIDEA_MODULE_BY_TEMPLATE_NO,
);
